module.exports = __webpack_public_path__ + "static/media/Slice1@2x.1840d468.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice1@2x.png
// module id = 1431
// module chunks = 0